import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Shop.css';
import '../css/Amazings.css';
import ls from 'local-storage';
import axios from 'axios';
import Retry from "./Retry";
import AppBody from "./AppBody";
import SliderImage from "../Modules/SliderImage";
import { CarouselProvider, Slider, Slide,DotGroup } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import AmazingProductsRow from "../Modules/AmazingProductsRow";
import ProductRowOfAmazing from "./ProductRowOfAmazing";
import CustomSlider from "./CustomSlider";
class Amazing extends React.Component{
    list =[];
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: true,
            amazingProducts: [],
            images:[],
        };
    }

    componentDidMount = () => {
        this.getAmazing();
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );

        let i = 0;
        return (
            <AppBody loading={this.state.loading} name={"شگفت انگیز ها"} type={" alice"} hasSlider={true}>
                <CustomSlider slides={this.state.images}/>
                {this.state.amazingProducts.map((amazingRow)=>{
                    return(
                        <div className={"AmazingProductsRow"}>
                            <div className={"amazing_store_name"}>{amazingRow.store_name}</div>
                            <ProductRowOfAmazing products={amazingRow.products}/>
                        </div>);
                })}

            </AppBody>
        );
    }



    getAmazing(){
        this.setState({loading:true});
        let data = {
            token:ls.get("token"),
            city_id:ls.get("city_id"),
        };
        axios.post(urls.baseUrl+urls.getAmazing,data)
            .then(res => {
                console.log("Amazing : ",res.data);
                if(res.data.code == 200){
                    let amazingProducts = [];
                    res.data.amazing_products.forEach((amazingProductRow)=>{
                        amazingProducts.push(new AmazingProductsRow(amazingProductRow));
                    });
                    let sliderImages = [];
                    res.data.sliders.forEach((image)=>{
                        sliderImages.push(new SliderImage(image));
                    });
                    this.setState({
                        images:sliderImages,
                        amazingProducts:amazingProducts,
                        loading:false
                    },
                        console.log("Amazing Data: ",amazingProducts));
                }
                else{
                    this.setState({loading:false});
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }

}



export default Amazing;
